// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetTeamMembersMultipleQueryVariables = Types.Exact<{
  query?: Types.InputMaybe<Types.Scalars['String']['input']>;
  selectedOptionsLike: Types.EmployeeWhereInput;
  first: Types.Scalars['Int']['input'];
}>;


export type GetTeamMembersMultipleQuery = { __typename?: 'Query', queryData: { __typename?: 'EmployeeConnection', totalCount: number, edges?: Array<{ __typename?: 'EmployeeEdge', node?: { __typename?: 'Employee', id: string, displayName: string, user: { __typename?: 'User', id: string } } | null } | null> | null }, selectedData: { __typename?: 'EmployeeConnection', totalCount: number, edges?: Array<{ __typename?: 'EmployeeEdge', node?: { __typename?: 'Employee', id: string, displayName: string, user: { __typename?: 'User', id: string } } | null } | null> | null } };

export const Operations = {
  Query: {
    GetTeamMembersMultiple: 'GetTeamMembersMultiple' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const GetTeamMembersMultipleDocument = gql`
    query GetTeamMembersMultiple($query: String, $selectedOptionsLike: EmployeeWhereInput!, $first: Int!) {
  queryData: employees(
    where: {hasUserWith: [{searchNameContainsFold: $query}]}
    first: $first
  ) {
    totalCount
    edges {
      node {
        id
        displayName
        user {
          id
        }
      }
    }
  }
  selectedData: employees(where: $selectedOptionsLike, first: $first) {
    totalCount
    edges {
      node {
        id
        displayName
        user {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetTeamMembersMultipleQuery__
 *
 * To run a query within a React component, call `useGetTeamMembersMultipleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamMembersMultipleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamMembersMultipleQuery({
 *   variables: {
 *      query: // value for 'query'
 *      selectedOptionsLike: // value for 'selectedOptionsLike'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetTeamMembersMultipleQuery(baseOptions: Apollo.QueryHookOptions<GetTeamMembersMultipleQuery, GetTeamMembersMultipleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamMembersMultipleQuery, GetTeamMembersMultipleQueryVariables>(GetTeamMembersMultipleDocument, withFetchPolicyContext(options));
      }
export function useGetTeamMembersMultipleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamMembersMultipleQuery, GetTeamMembersMultipleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamMembersMultipleQuery, GetTeamMembersMultipleQueryVariables>(GetTeamMembersMultipleDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useGetTeamMembersMultipleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTeamMembersMultipleQuery, GetTeamMembersMultipleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTeamMembersMultipleQuery, GetTeamMembersMultipleQueryVariables>(GetTeamMembersMultipleDocument, withFetchPolicyContext(options));
        }
export type GetTeamMembersMultipleQueryHookResult = ReturnType<typeof useGetTeamMembersMultipleQuery>;
export type GetTeamMembersMultipleLazyQueryHookResult = ReturnType<typeof useGetTeamMembersMultipleLazyQuery>;
export type GetTeamMembersMultipleSuspenseQueryHookResult = ReturnType<typeof useGetTeamMembersMultipleSuspenseQuery>;
export type GetTeamMembersMultipleQueryResult = Apollo.QueryResult<GetTeamMembersMultipleQuery, GetTeamMembersMultipleQueryVariables>;